var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440.71 393.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M754.37,431.13a227.74,227.74,0,0,1-7.92,59.78,201.83,201.83,0,0,1-9.58,27.76c-1.6,3.67-4.4,6.21-7.51,8.62q-5.13,4-10.62,7.45A137.49,137.49,0,0,1,617.31,553.1q-3.48-.74-6.92-1.67c-1.81-.48-3.74-.68-4.83-2.31a132.31,132.31,0,0,1-7.08-12.55,224.37,224.37,0,0,1-11.7-26.46,227,227,0,0,1,62.8-249.5q5.38-4.76,11.06-9.15a229.42,229.42,0,0,0-83.15,75.87C554.91,361.61,542.62,402,540.84,442.9a225.29,225.29,0,0,0,8.56,73.37,137.84,137.84,0,0,1-40.06-92.17c-.61-18.35,2.06-37.2,9.43-54.1a173.27,173.27,0,0,1,13.74-24.66A228.38,228.38,0,0,1,634.2,259.72,205.75,205.75,0,0,1,662,250c2.31-.62,3.27.69,5.06,2.09q3,2.35,5.92,4.8,5.65,4.74,11,9.84A226.89,226.89,0,0,1,753.87,416C754.21,421,754.37,426.08,754.37,431.13Z",
    transform: "translate(-428.4 -249.8)",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M869.12,502a228,228,0,0,1-54.86,62.08c10.4-30.49-21.36-65.06-51.63-59.24C773.36,466.27,846.92,486.51,869.12,502Z",
    transform: "translate(-428.4 -249.8)",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M494.74,468.84l1,16.76a137.47,137.47,0,0,0-67.37-83.67C467,417.88,494.74,429.21,494.74,468.84Z",
    transform: "translate(-428.4 -249.8)",
    fill: "#484848"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M685.88,593.74C589.25,688.07,516,642.26,497.93,498.19,515.55,579.56,609.49,627.4,685.88,593.74Z",
    transform: "translate(-428.4 -249.8)",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dbea88aedb7a254ea8cc40eca4a536c4.svg";
export { ForwardRef as ReactComponent };